import { CreateJobPath, ITestimonialData, JobDescriptionType, TRequirementLevelMap, TRequirementTypeMap } from "Components/CreateJob/CreateJobModel";
import { ILabelValueBase } from "shared/SharedModels";
import { JobLocationType } from "store/slices/employer/jobs/jobs-slice-model";

export const FullTimeId = 4;
export const JobValidity = 30;
export const MandatoryRequirementCategoryIds = [2, 3, 4];
export const TaxRate = 0.06;

export const DefaultState = 'Remote';

export const CreateJobStageMap: Partial<Record<CreateJobPath, number>> = {
    'title': 0,
    'details': 1,
    'preview': 2
};

export const CreateJobPaths: CreateJobPath[] = ['details', 'preview', 'title', 'bundles', 'payment'];

export const JobLocationTypes: ILabelValueBase<string, JobLocationType>[] = [
    { label: 'Remote', value: 'Fully Remote' },
    { label: 'Onsite', value: 'Onsite' },
    { label: 'Hybrid', value: 'Hybrid' }
];

export const ExperienceLevels: ILabelValueBase[] = [
    { label: 'Experienced', value: 'Experienced' },
    { label: 'Mid Level', value: 'Mid Level' },
    { label: 'Entry Level', value: 'Entry Level' }
];

export const RequirementCategoryMap: TRequirementTypeMap = {
    education: 'Education',
    qualification: 'Qualifications',
    responsibility: 'Job Duties',
    skill: 'Skills'
};

export const RequirementLevelMap: TRequirementLevelMap = {
    important: 'Important',
    must_have: 'Must have',
    nice_to_have: 'Nice to have'
};

export const JobDescriptionTypes: ILabelValueBase<string, JobDescriptionType>[] = [
    {
        label: 'Use Smoothhiring',
        value: 'sh'
    },
    {
        label: 'I will customize',
        value: 'custom'
    },
    {
        label: 'Use AI',
        value: 'ai'
    }
];

export const Months: ILabelValueBase[] = [
    { label: 'January', value: 'January' },
    { label: 'February', value: 'February' },
    { label: 'March', value: 'March' },
    { label: 'April', value: 'April' },
    { label: 'May', value: 'May' },
    { label: 'June', value: 'June' },
    { label: 'July', value: 'July' },
    { label: 'August', value: 'August' },
    { label: 'September', value: 'September' },
    { label: 'October', value: 'October' },
    { label: 'November', value: 'November' },
    { label: 'December', value: 'December' },
];

export const Years: ILabelValueBase[] = [
    { label: '2022', value: '2022' },
    { label: '2023', value: '2023' },
    { label: '2024', value: '2024' },
    { label: '2025', value: '2025' },
    { label: '2026', value: '2026' },
    { label: '2027', value: '2027' },
    { label: '2028', value: '2028' },
    { label: '2029', value: '2029' },
    { label: '2030', value: '2030' },
    { label: '2031', value: '2031' },
    { label: '2032', value: '2032' },
];

export const TestimonialData: ITestimonialData[] = [
    { review: "It’s the best service I have ever used for finding an employee! Love it! I have never experienced as many applicants for a position. We got over 105 applicants in 10 days! Awesome!", name: "Jim Williams - All Property Solutions, North Carolina" },
    { review: "SmoothHiring was like having a head-hunter screening applicants before I saw the resume. I found the process to be worth the investment for this reason alone. I didn't have to waste time scouring through dozens of applications to find the one or two that fit my needs.", name: "Derek Sparta – Sparta Graphics, California" },
];
